"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AlarmOn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlarmOn_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.854a.5.5 0 0 0-.708-.708l-.55.55a3.9 3.9 0 0 0-.039-.028.497.497 0 0 1-.11.178l-14.3 14.3a.5.5 0 0 0 .707.708L2.906 13.8c.176.187.361.363.556.53l-.816.815a.5.5 0 0 0 .708.708l.924-.925A6.967 6.967 0 0 0 8 16a6.967 6.967 0 0 0 3.722-1.07l.924.924a.5.5 0 0 0 .708-.708l-.816-.816A6.985 6.985 0 0 0 15 9c0-.927-.18-1.812-.508-2.622a3.496 3.496 0 0 0 .811-4.974l.55-.55ZM14.586 2.12 12.8 3.906a7.03 7.03 0 0 1 1.243 1.56 2.496 2.496 0 0 0 .542-3.345Zm-2.492 2.492L8.5 8.207V8.5h2a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.468-.325l-3.919 3.919A6.036 6.036 0 0 0 5.006 14.2C5.887 14.709 6.91 15 8 15a5.972 5.972 0 0 0 3.828-1.38A5.987 5.987 0 0 0 14 9a5.986 5.986 0 0 0-1.906-4.387ZM12.5 0c.413 0 .809.071 1.176.203l-.822.822a2.5 2.5 0 0 0-2.587 1.35c.3.103.59.225.87.366l-.751.752A5.963 5.963 0 0 0 8 3a6.039 6.039 0 0 0-2.005.343 6.019 6.019 0 0 0-3.589 3.483A5.985 5.985 0 0 0 2 9c0 .848.176 1.655.493 2.386l-.752.752A6.97 6.97 0 0 1 1 9c0-.927.18-1.812.508-2.622a3.5 3.5 0 1 1 5.209-4.26 7.04 7.04 0 0 1 2.567 0A3.5 3.5 0 0 1 12.5 0ZM1.956 5.466a7.021 7.021 0 0 1 3.777-3.09 2.5 2.5 0 1 0-3.777 3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.379V5a.5.5 0 0 0-1 0v1.379l1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlarmOn_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AlarmOn;
exports["default"] = _default;